module.exports = __webpack_public_path__ + "static/media/line.477d7a52.svg";